// Copyright (c) 2018 Deere & Company

import PictureRequestForm from '../state/picture-request-form';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const addFile = (state, action) =>
    PictureRequestForm.update(state, {
        files: {
            $push: [action.file]
        }
    });

const resetForm = state =>
    PictureRequestForm.update(state, {
        $set: getDefaultState().pictureRequestForm
    });

const updatePictRequestForm = (state, action) =>
    PictureRequestForm.update(state, {
        $set: action.pictRequestForm
    });

const updateComments = (state, action) =>
    PictureRequestForm.update(state, {
        courierInfo: {
            comments: {
                $set: action.comments
            }
        }
    });

const updateFile = (state, action) =>
    PictureRequestForm.update(state, {
        files: {
            $set: action.files
        }
    });

const updateReturnStatus = (state, action) =>
    PictureRequestForm.update(state, {
        returnStatus: {
            $set: action.returnStatus
        }
    });

export default (state = getDefaultState().pictureRequestForm, action) => {

    const actionHandlers = {
        [actions.ADD_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE]: addFile,
        [actions.RESET_REQUEST_DETAILS]: resetForm,
        [actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM]: updatePictRequestForm,
        [actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_COMMENTS]: updateComments,
        [actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE]: updateFile,
        [actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_RETURN_STATUS]: updateReturnStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/request-details/reducers/picture-request-form.js